import React, {
  useEffect,
  useState,
  useContext,
  useCallback,
  useMemo,
  useLayoutEffect,
} from "react";
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Modal,
  Row,
  TabContent,
  FormGroup,
} from "react-bootstrap";
import { AppContext, siteName } from "../main";
import { Parallax } from "react-parallax";
import { Helmet } from "react-helmet-async";
import Navbar from "../layout/Navbar";
import Services from './Services'
import Preloader from "../layout/preloader";
import SwiperComponent from "../section-pages/slider-home";
import Section1 from "../section-pages/section-1";
import ServiceList from "../section-pages/ServiceList";
import Location from "../section-pages/Location-center";
import Popular from "../section-pages/popular";
import useLocalStorage from "use-local-storage";
import { ArrowCircleDown, ArrowCircleUp, QuestionAnswer } from "@mui/icons-material";

import Reviews from "../section-pages/CustomerReviews";
import Servers from "../section-pages/Server";
import Collection from "../section-pages/Collection";
import Help from "../section-pages/help";
import Download from "../section-pages/Download";
import Payment from "../section-pages/Payment";
import Footer from "../section-pages/footer";
import ScrollToTopBtn from "../layout/ScrollToTop";
import { createGlobalStyle } from "styled-components";
import {
  getDataDB,
  saveDataDB,
  modifyDataModel,
  modifyTextAI,
  countWords,
  isDescriptionField,
  isImageField,
  handleFontAwesomeRedirect
} from "../api";
import moment from "moment";
import { MyFileUploader } from "../Components/MyFileUploader";

import Homestatic from "../section-pages/homestatic";
import Marquee from "../section-pages/marquee";
import Pricelist from "../section-pages/pricelist";
import Pricelist2 from "../section-pages/pricelist2";
import Videoanimate from "../section-pages/Videoanimate";
import Fashion from "./Fashion";



import Blog from "../section-pages/Blog-no-title";
import { Link, useLocation } from "react-router-dom";
import Section2 from "../section-pages/section-2";
import About from "../section-pages/about";
import Banner from "../section-pages/Banner";
import Banner2 from "../section-pages/Banner2";
import MenuLinksA from "../section-pages/MenuLinksA";
import MenuLinksC from "../section-pages/MenuLinksC";
import MenuLinksB from "../section-pages/MenuLinksB";
// import SiteTemplateA from "../section-pages/SiteTemplateA";  todo:fateh



const NavLink = (props) => {
  return <Link {...props} />;
};

const image1 = "../img/background/subheader-news.webp";
const image2 = "./img/background/4.webp";
const image3 = "./img/background/5.webp";
// const image1 = "./img/background/3.webp";

const GlobalStyles = createGlobalStyle`
  .navbar-brand .imginit{
      display: block ;
    }
    .navbar-brand .imgsaly{
      display: none !important;
    }
`;

const HomeScreen = (props) => {
  const { appState, setAppState } = useContext(AppContext);
  const location = useLocation();

  // console.log("location", location);

  const {
    editItemMain = {},
    editSection = "",
    editMode = false,
    hidden = [],
    payments = {},
    about = {},
    slides = {},
    collections = {},
    reviews = {},
    services = {},
    serviceList = {},
    faqs = {},
    homestatic = {},
    marquees = {},
    pricings = {},
    footers = {},
    banners = {},
    blogsnotitle = {},
    banners2 = {},
    pricelists = {},
    videoanimates = {},
    locations = {},
    populars = {},
    menuas = {},
    menubs = {},
    duplicates = [],
    newBgColor = "#1E1F22",
    newTextColor = "#000000",
    myorder = [
      "navbars",
      "menubs",
      "menuas",
      // "menucs",
      "swiper",
      "serviceList",
      "aboutUs",
      "reviews",
      "collections",
      "help",
      "payment",
      "homestatic",
      "marquees",
      "blogs",
      "pricings",
      "pricelists",
      "videoanimates",
      "locations",
      "populars",
      "banners",
      "banners2",
      "footers",
    ],
    navbars = {},
    // reviewsHeader,
    // collectionsHeader,
    bannerPointer,
    blog = {},
    industryType = '',
    showServices = false
  } = appState;
  const [modalOpen, setModalOpen] = useState(false);
  const [editItem, setEditItem] = useState({});
  const [loading, setLoading] = useState(false);
  // const [showServices, setShowServices] = useState(false);



  const handleEditClick = (slide) => {
    setEditItem(slide);
    setModalOpen(true);
  };

  const handleSaveConfig = ({ section, config }) => {
    // alert(section)

    setAppState((existing) => {
      return {
        ...existing,
        editItemMain: config,
        editSection: section,
      };
    });
  };

  const handleSave = useCallback(
    (item) => {
      // alert(JSON.stringify(item))
      if (appState?.[editSection] && Array.isArray(appState?.[editSection])) {
        const index = appState?.[editSection]?.findIndex(
          (res) => res.id == item?.id
        );
        appState[editSection][
          index >= 0 ? index : appState?.[editSection]?.length + 1
        ] = item;
      } else if (
        appState?.[editSection] &&
        typeof appState?.[editSection] == "object"
      ) {
        appState[editSection] = item;
      }
      delete appState?.editSection;
      delete appState?.section;
      delete appState?.editMode;

      // console.log('cccccc', 2222, editSection, appState?.[editSection])
      // return
      if (appState)
        saveDataDB({
          query: {
            date: moment(),
            config: appState,
            siteName: siteName
          },
          keys: ["siteName"],
          resource: "vare_sites",
        }).then((info) => {
          setEditItem({});
          setAppState((existing) => {
            return {
              ...existing,
              ...info?.[0]?.config,
              editItemMain: {},
              section: "",
            };
          });
          setLoading(false)
          // console.log('cccccc', info?.[0]?.config,)
        });
    },
    [editSection]
  );

  useEffect(() => {
    if (typeof window !== "undefined") {
      const loader = document.getElementById("mainpreloader");
      if (loader && appState?.backupConfig) {
        setTimeout(() => {
          loader.classList.add("fadeOut");
          loader.style.display = "none";
        }, 600);
      }
    }
  }, [
    appState?.backupConfig
  ]);

  // useEffect(() => {
  //   if (location.pathname === "/collections") {
  //     const collectionSection = document.getElementById("collections");
  //     console.log("collectionSection", collectionSection);
  //     if (collectionSection) {
  //       collectionSection.scrollIntoView({ behavior: "smooth" });
  //     }
  //   }
  // }, [location.pathname]);

  useEffect(() => {
    // Map routes to their corresponding section IDs
    const routeToSectionMap = {
      "/collections": "collections",
      "/help": "faq",
      "/swiper": "swiper",
      // Add more routes and their corresponding section IDs here
    };

    console.log("routeToSectionMap", routeToSectionMap);
    // Get the section ID based on the current route
    const sectionId = routeToSectionMap[location.pathname];
    console.log("sectionId", sectionId);

    if (sectionId) {
      const sectionElement = document.getElementById(sectionId);
      console.log("sectionElement", sectionElement);
      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location.pathname]);


  useEffect(() => {
    if (location.hash) {
      const sectionId = location.hash.replace("#", "");
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const mainComponent = useMemo(() => {
    const temp = [
      // {
      //   name: "navbars",
      //   component: (
      //     <header id="header-wrap" >
      //       <Navbar
      //         navOptions={{
      //           nav_links: [
      //             ...(navbars?.nav_links || []),
      //           ],
      //           logo_desktop: {
      //             ...(navbars?.logo_desktop || {}),

      //           },
      //           logo_mobile: {
      //             ...(navbars?.logo_mobile || {}),

      //           },
      //           logo_images: {
      //             ...(navbars?.logo_images || {}),
      //           },
      //         }}
      //         navEdit={true}
      //       />
      //     </header>
      //   ),
      //   onClick: () => {
      //     handleSaveConfig({
      //       section: "navbars",
      //       config: navbars || {},
      //     });
      //   },

      // },
      {
        name: "swiper",
        component: (
          <div id="swiper" className="no-bg">
            <SwiperComponent />
          </div>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "slides",
            config: slides || {},
          });
        },
      },
      {
        name: "serviceList",
        component: <div id="serviceList">
          <ServiceList />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "serviceList",
            config: serviceList || {},
          });
        },
      },
      {
        name: "aboutUs",
        component: <div id="aboutUs">
          <About />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "about",
            config: about || {},
          });
        },
      },
      {
        name: "reviews",
        component: <div id="reviews">
          <Reviews />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "reviews",
            config: reviews || {},
          });
        },
      },
      {
        name: "collections",
        component: (
          <Parallax bgImage={image1} strength={300}>
            <div id="collections" className="no-bg">
              <Collection />
            </div>
          </Parallax>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "collections",
            config: collections || {},
          });
        },
      },
      {
        name: "help",
        component: (
          <div id="faq">
            <Help />
          </div>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "faqs",
            config: faqs || {},
          });
        },
      },
      {
        name: "payment",
        component: <div id="payment">
          <Payment />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "payments",
            config: payments || {},
          });
        },
      },
      {
        name: "homestatic",
        component: (
          <Parallax className="bgcolor" bgImage={image2} strength={300}>
            <div id="homestatic" className="pt60 no-bottom">
              <Homestatic handleEditItem={handleSaveConfig} />
            </div>
          </Parallax>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "homestatic",
            config: homestatic || {},
          });
        },
      },
      {
        name: "marquees",
        component: <div id="marquees">
          <Marquee />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "marquees",
            config: marquees || {},
          });
        },
      },
      {
        name: "blogs",
        component: <div id="blogs">
          <Blog />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "blogsnotitle",
            config: blogsnotitle || {},
          });
        },
      },
      {
        name: "pricings",
        component: (
          <Parallax bgImage={image3} strength={150}>
            <div id={"pricings"} className="no-bg pt60 no-bottom">
              <Pricelist />
            </div>
          </Parallax>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "pricings",
            config: pricings || {},
          });
        },
      },
      {
        name: "pricelists",
        component: (
          <Parallax bgImage={image3} strength={150}>
            <div id={"pricelists"} className="no-bg pt60 no-bottom">
              <Pricelist2 />
            </div>
          </Parallax>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "pricelists",
            config: pricelists || {},
          });
        },
      },
      {
        name: "videoanimates",
        component: (
          <div id={"videoanimates"} className="no-bg pt60 no-bottom">
            <Videoanimate />
          </div>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "videoanimates",
            config: videoanimates || {},
          });
        },
      },

      {
        name: "locations",
        component: (
          <div id={"locations"} className="no-bg pt60 no-bottom">
            <Location />
          </div>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "locations",
            config: locations || {},
          });
        },
      },
      {
        name: "populars",
        component: (
          <div id={"populars"} className="no-bg pt60 no-bottom">
            <Popular />
          </div>
        ),
        onClick: () => {
          handleSaveConfig({
            section: "populars",
            config: populars || {},
          });
        },
      },
      {
        name: "menubs",
        component: <div id={"menubs"}>
          <MenuLinksB />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "menubs",
            config: menubs || {},
          });
        },
      },

      {
        name: "banners",
        component: <div id={"banners"}>
          <Banner />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "banners",
            config: banners || {},
          });
        },
      },
      {
        name: "banners2",
        component: <div id={"banners2"}>
          <Banner2 />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "banners2",
            config: banners2 || {},
          });
        },
      },
      {
        name: "footers",
        component: <div id={"footers"}>
          <Footer />
        </div>,
        onClick: () => {
          handleSaveConfig({
            section: "footers",
            config: footers || {},
          });
        },
      },
    ];
    const data = []
    myorder?.map(
      (name) => {
        const info = name && temp?.filter((ref) => ref.name && name == ref.name)?.[0]
        if (info) {
          data.push(info)
        }
      }
    );
    return data;
  }, [
    blogsnotitle,
    pricings,
    payments,
    about,
    slides,
    collections,
    reviews,
    services,
    serviceList,
    homestatic,
    faqs,
    marquees,
    banners,
    banners2,
    pricelists,
    videoanimates,
    locations,
    populars,
    menuas,
    menubs,
    myorder,
    newBgColor,
    newTextColor,
    navbars,
    duplicates
  ]);


  // const [bgColor, setBgColor] = useState('#1E1F22');


  const handleColorChange = useCallback(async (e) => {
    const newColor = e.target.value;
    if (!newColor) {
      return
    }
    appState["newBgColor"] = newColor;
    // alert(appState?.newBgColor)
    delete appState?.editSection;
    delete appState?.section;
    delete appState?.editMode;
    await saveDataDB({
      query: {
        date: moment(),
        config: appState,
        siteName: siteName,
      },
      keys: ["siteName"],
      resource: "vare_sites",
    }).then((info) => {
      // console.log('ccccccc', info)
      setAppState((existing) => {
        return {
          ...existing,
          newBgColor: newColor,
        };
      });
    });
    // Update all elements with bg-dark-1 class
    document.querySelectorAll('.bg-dark-1').forEach(element => {
      element.style.backgroundColor = newColor;
    });

    // Update body background
    document.body.style.backgroundColor = newColor;

    // Update any elements using the CSS variable
    document.documentElement.style.setProperty('--bg-dark-1', newColor);
  }, [
    appState
  ]);

  const handleTextColor = useCallback(async (e) => {
    const newColor = e.target.value;
    if (!newColor) {
      return
    }
    appState["newTextColor"] = newColor;
    delete appState?.editSection;
    delete appState?.section;
    delete appState?.editMode;
    await saveDataDB({
      query: {
        date: moment(),
        config: appState,
        siteName: siteName,
      },
      keys: ["siteName"],
      resource: "vare_sites",
    }).then((info) => {
      setAppState((existing) => {
        return {
          ...existing,
          newTextColor: newColor,
        };
      });
    });
  }, [appState]);

  useEffect(() => {
    // alert(newBgColor)
    document.querySelectorAll('.bg-dark-1').forEach(element => {
      element.style.backgroundColor = newBgColor;
    });

    // Update body background
    document.body.style.backgroundColor = newBgColor;
    document.getElementById("root").style.backgroundColor = newBgColor;


    // Update any elements using the CSS variable
    document.documentElement.style.setProperty('--bg-dark-1', newBgColor);
  }, [
    newBgColor
  ])

  const GlobalStyles = createGlobalStyle`
  body * {
    color: ${newTextColor} !important;
    // background: ${newBgColor} !important
  }
  .accordion-item .accordion-button {
    color: ${newTextColor} !important;
  }
  a.btn-main .btn-main {
    color: ${newTextColor} !important;
    background: ${newBgColor} !important;
  }
  .home-video h1 {
  // color: ${newTextColor}
  // background: linear-gradient(0deg, #888888 0%, #0f0f0f 75%)
  }
  .modal-content * {
  color: black !important;
  background-color: white !important
  }
`;

  return (
    <>
      {showServices && <Modal
        show={true}
        onHide={() => {
          // setLoadType(false);
          setAppState((existing) => {
            return {
              ...existing,
              showServices: false,
            };
          });
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Our Services</Modal.Title>
        </Modal.Header>
        <Modal.Body>Start Here</Modal.Body>
        <Modal.Footer
          style={{
            display: "flex",
            width: "100%",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Services
            {...props}

          />
        </Modal.Footer>
      </Modal>}

      {/* HEAD */}
      <Helmet>
        <link rel="icon" href="./img/icon.png" />
        <title>Vare Technology Digital - {siteName}</title>
      </Helmet>

      <GlobalStyles />

      {/* LOADER */}
      <div id="mainpreloader">
        <Preloader />
      </div>
      {/* MENU */}

      {!modalOpen && Object.keys(editItemMain)?.[0]
        ? (
          <EditModal
            item={editItemMain}
            onSave={handleSave}
            loading={loading}
            setLoading={setLoading}
            onClose={() => {
              setModalOpen(false)
              setEditItem({})
              setAppState((existing) => {
                return {
                  ...existing,
                  editItemMain: {},
                  section: ''
                };
              });
            }}

          />
        )
        :
        <div className="home dark-scheme" style={{

        }}>

          {siteName == 'fashion' && <Fashion />}

          <>
  {/* Static Navbar */}
  <header id="header-wrap">
    <Navbar
      navOptions={{
        nav_links: [...(navbars?.nav_links || [])],
        logo_desktop: { ...(navbars?.logo_desktop || {}) },
        logo_mobile: { ...(navbars?.logo_mobile || {}) },
        logo_images: { ...(navbars?.logo_images || {}) },
      }}
      navEdit={true}
    />
  </header>

  {/* Dynamic Sections */}
  {mainComponent?.map((res, i) => (
    <div key={res?.name}>
                {editMode && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexDirection: "row",
                      marginTop: i == 0 ? 80 : 0,
                      gap: 20,
                    }}
                  >
                    <NavLink
                      to="#"
                      className={editMode ? "btn-line" : "btn"}
                      id="btn-line"
                      onClick={() => {
                        res?.onClick();
                      }}
                      style={{
                        marginLeft: 100,
                        margin: 20,
                      }}
                    >
                      {"Edit"}
                    </NavLink>

                    {myorder[i - 1] && (
                      <NavLink
                        to="#"
                        className={editMode ? "btn-line" : "btn"}
                        id="btn-line"
                        onClick={() => {
                          if (myorder[i - 1]) {
                            const report = reorderArray({
                              array: myorder,
                              fromIndex: i,
                              toIndex: i - 1,
                            });
                            appState["myorder"] = report;
                            delete appState?.editSection;
                            delete appState?.section;
                            delete appState?.editMode;
                            saveDataDB({
                              query: {
                                date: moment(),
                                config: appState,
                                siteName: siteName,
                              },
                              keys: ["siteName"],
                              resource: "vare_sites",
                            }).then((info) => {
                              setAppState((existing) => {
                                return {
                                  ...existing,
                                  myorder: report,
                                  editMode: true
                                };
                              });
                            });
                          }
                        }}
                        style={{
                          marginLeft: 100,
                          margin: 20,
                        }}
                      >
                        <ArrowCircleUp />
                      </NavLink>
                    )}

                    {myorder[i + 1] && (
                      <NavLink
                        to="#"
                        className={editMode ? "btn-line" : "btn"}
                        id="btn-line"
                        onClick={() => {
                          if (myorder[i + 1]) {
                            const report = reorderArray({
                              array: myorder,
                              fromIndex: i,
                              toIndex: i + 1,
                            });
                            appState["myorder"] = report;
                            delete appState?.editSection;
                            delete appState?.section;
                            delete appState?.editMode;
                            saveDataDB({
                              query: {
                                date: moment(),
                                config: appState,
                                siteName: siteName,
                              },
                              keys: ["siteName"],
                              resource: "vare_sites",
                            }).then((info) => {
                              setAppState((existing) => {
                                return {
                                  ...existing,
                                  myorder: report,
                                  editMode: true
                                };
                              });
                            });
                          }
                        }}
                        style={{
                          marginLeft: 100,
                          margin: 20,
                        }}
                      >
                        <ArrowCircleDown />
                      </NavLink>
                    )}

                    <NavLink
                      to="#"
                      className={editMode ? "btn-line" : "btn"}
                      id="btn-line"
                      onClick={() => {

                        const report = insertStringAtIndex({
                          array: myorder,
                          index: i,
                          newItem: res?.name
                        })
                        if (!duplicates?.includes(res?.name)) {
                          duplicates?.push(res?.name)
                        }
                        appState["myorder"] = report;
                        appState["duplicates"] = duplicates;

                        delete appState?.editSection;
                        delete appState?.section;
                        delete appState?.editMode;
                        saveDataDB({
                          query: {
                            date: moment(),
                            config: appState,
                            siteName: siteName,
                          },
                          keys: ["siteName"],
                          resource: "vare_sites",
                        }).then((info) => {
                          setAppState((existing) => {
                            return {
                              ...existing,
                              myorder: report,
                              editMode: true
                            };
                          });
                        });
                      }}
                      style={{
                        marginLeft: 100,
                        margin: 20,
                      }}
                    >
                      {"Add"}
                    </NavLink>

                    {duplicates?.[0] && duplicates?.includes(res.name) && <NavLink
                      to="#"
                      className={editMode ? "btn-line" : "btn"}
                      id="btn-line"
                      onClick={() => {
                        const report = removeFirstMatch({
                          array: myorder,
                          target: res?.name
                        })
                        const dupdelete = duplicates?.includes(res?.name)
                          && duplicates?.length > 0
                          && removeFirstMatch({
                            array: duplicates,
                            target: res?.name
                          })

                        appState["myorder"] = report;
                        if (dupdelete) appState["duplicates"] = dupdelete;
                        delete appState?.editSection;
                        delete appState?.section;
                        delete appState?.editMode;
                        saveDataDB({
                          query: {
                            date: moment(),
                            config: appState,
                            siteName: siteName,
                          },
                          keys: ["siteName"],
                          resource: "vare_sites",
                        }).then((info) => {
                          setAppState((existing) => {
                            return {
                              ...existing,
                              myorder: report,
                              editMode: true
                            };
                          });
                        });
                      }}
                      style={{
                        marginLeft: 100,
                        margin: 20,
                      }}
                    >
                      {"Delete"}
                    </NavLink>
                    }



                    <NavLink
                      to="#"
                      className={editMode ? "btn-line" : "btn"}
                      id="btn-line"
                      onClick={() => {
                        if (hidden?.includes(res.name)) {
                          const report = hidden.filter(
                            (name) => name !== res.name
                          );
                          appState["hidden"] = report;
                          delete appState?.editSection;
                          delete appState?.section;
                          delete appState?.editMode;
                          saveDataDB({
                            query: {
                              date: moment(),
                              config: appState,
                              siteName: siteName,
                            },
                            keys: ["siteName"],
                            resource: "vare_sites",
                          }).then((info) => {
                            setAppState((existing) => {
                              return {
                                ...existing,
                                hidden: report,
                                editMode: true
                              };
                            });
                          });
                        } else {
                          const report = [...hidden, res.name];
                          appState["hidden"] = report;
                          delete appState?.editSection;
                          delete appState?.section;
                          delete appState?.editMode;
                          saveDataDB({
                            query: {
                              date: moment(),
                              config: appState,
                              siteName: siteName,
                            },
                            keys: ["siteName"],
                            resource: "vare_sites",
                          }).then((info) => {
                            setAppState((existing) => {
                              return {
                                ...existing,
                                hidden: [...hidden, res.name],
                                editMode: true
                              };
                            });
                          });
                        }
                      }}
                      style={{
                        marginLeft: 100,
                        margin: 20,
                      }}
                    >
                      {hidden?.includes(res.name) ? "Show" : "Hide"}
                    </NavLink>

                    {i == 0 && <div
                      // to="#"
                      className={"btn"}
                      id="btn-line"
                      // onClick={() => {
                      //   res?.onClick();
                      // }}
                      style={{
                        marginLeft: 100,
                        margin: 20,
                      }}
                    >
                      <div style={{
                        display: 'flex',
                        flexDirection: "row",
                        gap: 20,
                        zIndex: 99999,
                        alignItems: 'center'
                      }}>
                        <label
                          htmlFor="bgColor"
                          style={{
                            color: 'white',
                            // marginRight: '10px' 
                          }}>
                          Background Color:
                        </label>
                        <input
                          type="color"
                          id="bgColor"
                          onChange={handleColorChange}
                          value={newBgColor}
                        />
                        <label
                          htmlFor="textColor"
                          style={{
                            color: 'white',
                            // marginRight: '10px' 
                          }}>
                          Text Color:
                        </label>
                        <input
                          type="color"
                          id="textColor"
                          onChange={handleTextColor}
                          value={newTextColor}
                        />
                      </div>

                    </div>}

                    <div style={{
                      color: 'white'
                    }}>{res.name}
                    </div>
                  </div>
                )}
      {/* all your editMode buttons and control logic stays here */}
      {!hidden?.includes(res.name) && (
        <div style={{ paddingTop: 10, paddingBottom: 10 }}>
          {res?.component}
        </div>
      )}
    </div>
  ))}
</>

        </div>
      }
      <ScrollToTopBtn />
    </>
  );
};

export default HomeScreen;

export const EditModal = (props) => {
  const { item, onSave, onClose, setLoading, loading } = props;
  const { appState } = useContext(AppContext);
  const { editSection, defaultConfig = {} } = appState;
  const [myStore, setMyStore] = useLocalStorage("name", {});
  const {
    myInfo,
    // myInfo: { siteName = "banking-v1" },
  } = myStore;
  const siteName = appState?.myContext?.myInfo?.siteName || appState?.siteName || 'banking-v1';

  const [editedItem, setEditedItem] = useState(item || {});
  const [imageFiles, setImageFiles] = useState({});
  const [refreshing, setRefreshing] = useState(false);
  const [uploadNow, setUploadNow] = useState(false);
  const [formInputState, setFormInputState] = useState(false);

  const [aiLoading, setAILoading] = useState(false);
  const [fieldWithAI, setFieldWithAI] = useState(null);
  const [aILoadingNow, setAILoadingNow] = useState(false);

  const [stripeKey, setStripeKey] = useState({});

  useEffect(() => { //todo:dee add to other applications
    setEditedItem(item)
  }, [
    item
  ])




  // const handleInputChange = (key, value) => {
  //     setEditedItem((prev) => ({ ...prev, [key]: value }));
  // };

  const handleInputChange = (key, value) => {
    setEditedItem((prev) => ({ ...prev, [key]: value !== undefined && value !== null ? String(value) : '' }));
  };


  const handleNestedChange = (parentKey, nestedKey, value) => {
    setEditedItem((prev) => ({
      ...prev,
      [parentKey]: {
        ...prev[parentKey],
        [nestedKey]: value,
      },
    }));
  };

  const handleArrayChange = (arrayKey, index, key, value) => {
    const updatedArray = editedItem[arrayKey]?.map((item, i) =>
      i === index ? { ...item, [key]: value } : item
    );
    setEditedItem((prev) => ({ ...prev, [arrayKey]: updatedArray }));
  };

  const moveArrayItem = (arrayKey, index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= editedItem[arrayKey].length) return;

    const updatedArray = [...editedItem[arrayKey]];
    [updatedArray[index], updatedArray[newIndex]] = [
      updatedArray[newIndex],
      updatedArray[index],
    ];

    setEditedItem((prev) => ({ ...prev, [arrayKey]: updatedArray }));
  };


  const addArrayItem = (arrayKey) => {
    setEditedItem((prev) => {
      const existingArray = prev[arrayKey] || [];

      // Try to get a sample template from existing items or the default config
      let templateSource = existingArray.find(
        (item) => typeof item === "object"
      );

      if (!templateSource) {
        templateSource = defaultConfig?.[editSection]?.[arrayKey]?.[0] || {};
      }

      const generateEmptyValue = (value) => {
        if (typeof value === "number") return 0;
        if (typeof value === "boolean") return false;
        if (Array.isArray(value)) return [];
        if (typeof value === "object" && value !== null) {
          return Object.fromEntries(
            Object.entries(value).map(([k, v]) => [k, generateEmptyValue(v)])
          );
        }
        return "";
      };

      const newItem = Object.fromEntries(
        Object.entries(templateSource).map(([k, v]) => [
          k,
          k === "id" ? existingArray.length + 1 : generateEmptyValue(v),
        ])
      );

      return {
        ...prev,
        [arrayKey]: [...existingArray, newItem],
      };
    });
  };
  const [removedItemIds, setRemovedItemIds] = useState({});

  // const removeArrayItem = (arrayKey, index) => {
  //     setEditedItem((prev) => ({
  //         ...prev,
  //         [arrayKey]: prev[arrayKey].filter((_, i) => i !== index),
  //     }));
  // };
  const removeArrayItem = (arrayKey, index) => {
    setEditedItem((prev) => ({
      ...prev,
      [arrayKey]: prev[arrayKey].filter((_, i) => i !== index),
    }));

    // Update the defaultConfig in-place to reflect the deletion
    if (defaultConfig?.[editSection]?.[arrayKey]) {
      defaultConfig[editSection][arrayKey] = defaultConfig[editSection][arrayKey].filter((_, i) => i !== index);
    }
  };


  const isDefault = useMemo(() => {
    return (
      JSON.stringify(defaultConfig[editSection]) == JSON.stringify(editedItem)
    );
  }, [appState, editSection, editedItem]);

  // const cleanedItem = useCallback((editedItem) => {
  //     return Object.fromEntries(
  //         Object.entries(editedItem).map(([k, v]) => {
  //             if (Array.isArray(v)) {
  //                 return [
  //                     k,
  //                     v.filter((entry) => Object.values(entry).some((val) => val !== "")),
  //                 ];
  //             }
  //             return [k, v];
  //         })
  //     );
  // }, []);
  // const [removedItemIds, setRemovedItemIds] = useState({});

  const cleanedItem = useCallback((editedItem) => {
    return Object.fromEntries(
      Object.entries(editedItem).map(([k, v]) => {
        if (Array.isArray(v)) {
          const removedIds = removedItemIds[k] || [];

          const filtered = v.filter(entry => {
            const isRemoved = removedIds.includes(entry.id);
            if (isRemoved) return false;

            return Object.values(entry).some(val => {
              if (typeof val === 'string') return val.trim() !== '';
              if (Array.isArray(val)) return val.length > 0;
              if (typeof val === 'object' && val !== null) return Object.keys(val).length > 0;
              return val !== null && val !== undefined;
            });
          });

          return [k, filtered];
        }
        return [k, v];
      })
    );
  }, [removedItemIds]);


  useEffect(() => { }, [fieldWithAI]);

  return (
    <div
      style={{
        width: "100%",
        zIndex: 5,
        height: "auto",
        display: "flex",
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
        padding: 50,
      }}
    >
      {aILoadingNow && (
        <div
          style={{
            position: "absolute",
            zIndex: 99999,
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            height: "100%",
            width: "100%",
            fontSize: 40,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Loading....
        </div>
      )}
      <div
        className="modal-content"
        style={{
          width: 500,
          display: "flex",
          flexDirection: "column",
          gap: 20,
          padding: 20,
        }}
      >
        <h2>{`Edit ${editSection}`}</h2>

        {editedItem?.aiAssist && (
          <div
            style={{
              padding: 20,
            }}
          >
            {" "}
            <AiPromptBox
              handleText={(text) => {
                // alert(text)
                setAILoading(true);
                modifyDataModel({
                  industry: text,
                  dataModel: defaultConfig?.[editSection],
                }).then((res) => {
                  // console.log('xxxxxxxx', res)
                  setEditedItem(res);
                  setAILoading(false);
                });
              }}
              aiLoading={aiLoading}
            />
          </div>
        )}

        {!isDefault && (
          <button
            className="btn-main"
            onClick={() => setEditedItem(defaultConfig[editSection])}
            style={{
              marginLeft: 30,
              marginRight: 30,
            }}
          >
            Reset to Default
          </button>
        )}

        {Object.entries(editedItem)?.map(([key, value], index) => {
          if (
            // key === "menu" &&
            typeof value === "boolean"
          ) {
            return (
              <div
                key={key}
                style={{ display: "flex", alignItems: "center", gap: 10 }}
              >
                <label style={{ minWidth: "100px" }}>{key}</label>
                <input
                  type="checkbox"
                  checked={value}
                  onChange={(e) => handleInputChange(key, e.target.checked)}
                />
              </div>
            );
          }
          if (Array.isArray(value)) {
            return (
              <div
                key={key}
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                {value.map((entry, index) => (
                  <div
                    key={entry.id ?? index}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 5,
                      borderBottom: "1px solid #ddd",
                      paddingBottom: 10,
                    }}
                  >
                    {Object.entries(entry)?.map(([field, fieldValue]) => {
                      const isDate = field.toLowerCase() == "date" || field == "endDate";
                      if (field !== "id") {
                        if (
                          Array.isArray(fieldValue) &&
                          fieldValue.every((v) => typeof v === "object")
                        ) {
                          return (
                            <div
                              key={field}
                              style={{
                                marginLeft: 20,
                                borderLeft: "2px solid #eee",
                                paddingLeft: 10,
                              }}
                            >
                              <label style={{ fontWeight: "bold" }}>
                                {field.charAt(0).toUpperCase() + field.slice(1)}
                              </label>
                              {fieldValue.map((subItem, subIndex) => (
                                <div
                                  key={subIndex}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 5,
                                    marginBottom: 5,
                                  }}
                                >
                                  {Object.entries(subItem).map(
                                    ([subKey, subValue]) => (
                                      <div
                                        key={subKey}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 10,
                                        }}
                                      >
                                        <label style={{ minWidth: "60px" }}>
                                          {subKey}
                                        </label>
                                        <input
                                          type={
                                            subKey == "Day" ? "datetime-local" : "text"
                                          }
                                          value={subValue}
                                          onChange={(e) => {
                                            const updatedArray = [
                                              ...editedItem[key],
                                            ];
                                            updatedArray[index][field][
                                              subIndex
                                            ][subKey] = e.target.value;
                                            setEditedItem((prev) => ({
                                              ...prev,
                                              [key]: updatedArray,
                                            }));
                                          }}
                                          style={{ flex: 1 }}
                                        />
                                      </div>
                                    )
                                  )}
                                  <button
                                    onClick={() => {
                                      const updatedArray = [...editedItem[key]];
                                      updatedArray[index][field] = updatedArray[
                                        index
                                      ][field].filter((_, i) => i !== subIndex);
                                      setEditedItem((prev) => ({
                                        ...prev,
                                        [key]: updatedArray,
                                      }));
                                    }}
                                    style={{
                                      color: "red",
                                      border: "none",
                                      background: "none",
                                      alignSelf: "flex-start",
                                    }}
                                  >
                                    Remove
                                  </button>
                                </div>
                              ))}
                              <button
                                onClick={() => {
                                  const updatedArray = [...editedItem[key]];
                                  updatedArray[index][field] = [
                                    ...updatedArray[index][field],
                                    { name: "" },
                                  ];
                                  setEditedItem((prev) => ({
                                    ...prev,
                                    [key]: updatedArray,
                                  }));
                                }}
                              >
                                Add Item
                              </button>
                            </div>
                          );
                        }
                        return (
                          <div
                            key={field}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 5,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                              }}
                            >
                              <label style={{ minWidth: "80px" }}>
                                {field.charAt(0).toUpperCase() + field.slice(1)}
                              </label>
                              <input
                                // type="text"
                                type={isDate ? "datetime-local" : "text"}
                                value={fieldValue}
                                onChange={(e) =>
                                  handleArrayChange(
                                    key,
                                    index,
                                    field,
                                    e.target.value
                                  )
                                }
                                style={{ flex: 1 }}
                              />
                              {!isImageField(`${field}`) &&
                                typeof fieldValue === 'string'
                                && !fieldValue.includes(".com")
                                && isDescriptionField(`${field}`)
                                && (
                                  <button
                                    onClick={() => {
                                      modifyTextAI({
                                        text: fieldValue,
                                        length: fieldValue ? countWords(fieldValue) : 10,
                                      }).then((res) => {
                                        // alert(JSON.stringify(res))
                                        if (res) {
                                          handleArrayChange(
                                            key,
                                            index,
                                            field,
                                            res
                                          )
                                        }
                                      });
                                    }}
                                    style={{
                                      // background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      backgroundColor: "blue",
                                      color: "white",
                                    }}
                                    title="Generate with AI"
                                  >
                                    AI (Task)
                                  </button>
                                )}
                              {field == 'icon' && (
                                <QuestionAnswer
                                  onClick={() => {
                                    handleFontAwesomeRedirect()
                                  }}
                                />
                              )}
                            </div>
                            {isImageField(field) && (
                              <MyMedia
                                fieldValue={fieldValue}
                                entry={entry}
                                handleNewFile={() => { }}
                                defaultItem={defaultConfig[editSection]}
                              />
                            )}
                          </div>
                        );
                      }
                      return null;
                    })}

                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <label>ID</label>
                      <input
                        type="number"
                        value={entry.id}
                        readOnly
                        style={{ width: 60, textAlign: "center" }}
                      />
                      <button
                        onClick={() => moveArrayItem(key, index, -1)}
                        disabled={index === 0}
                      >
                        &uarr;
                      </button>
                      <button
                        onClick={() => moveArrayItem(key, index, 1)}
                        disabled={index === value.length - 1}
                      >
                        &darr;
                      </button>
                    </div>

                    <button
                      onClick={() => removeArrayItem(key, index)}
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        border: "none",
                        padding: "5px 10px",
                      }}
                    >
                      Remove
                    </button>
                  </div>
                ))}
                <button
                  onClick={() =>
                    addArrayItem(key, {
                      title: "",
                      header: "",
                      price: "",
                      image: "",
                      description: "",
                    })
                  }
                  className="btn-main"
                >
                  Add {key.slice(0, -1)}
                </button>
              </div>
            );
          }

          if (typeof value === "object" && value !== null) {
            return (
              <div
                key={key}
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                {Object.entries(value)?.map(([nestedKey, nestedValue]) => (
                  <div
                    key={nestedKey}
                    style={{ display: "flex", flexDirection: "column", gap: 5 }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <label style={{ minWidth: "80px" }}>{nestedKey}</label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flex: 1,
                          gap: 5,
                        }}
                      >

                        <textarea
                          value={nestedValue}
                          onChange={(e) =>
                            handleNestedChange(key, nestedKey, e.target.value)
                          }
                          style={{
                            // flex: 1,
                            width: '100%',
                            height: "1.5em", // height of one line (adjust as needed)
                            lineHeight: "1.5em", // ensure vertical centering
                            overflowY: "auto",
                            resize: "vertical",
                          }}
                        />
                        {!isImageField(`${key}.${nestedKey}`) &&
                          !nestedValue?.includes(".com")
                          && isDescriptionField(`${key}.${nestedKey}`)
                          && (
                            <button
                              onClick={() => {
                                modifyTextAI({
                                  text: nestedValue,
                                  length: value ? countWords(value) + 20 : 100,
                                }).then((res) => {
                                  // alert(JSON.stringify(res))
                                  if (res)
                                    handleNestedChange(key, nestedKey, res);
                                });
                              }}
                              style={{
                                // background: "none",
                                border: "none",
                                cursor: "pointer",
                                backgroundColor: "blue",
                                color: "white",
                              }}
                              title="Generate with AI"
                            >
                              AI (Task)
                            </button>
                          )}
                        {`${key}.${nestedKey}` == 'icon' && (
                          <QuestionAnswer
                            onClick={() => {
                              handleFontAwesomeRedirect()
                            }}
                          />
                        )}
                      </div>
                    </div>
                    {isImageField(nestedValue) && (
                      <MyMedia
                        fieldValue={nestedValue}
                        entry={value}
                        handleNewFile={() => { }}
                        defaultItem={defaultConfig[editSection]}
                      />
                    )}
                  </div>
                ))}
              </div>
            );
          }

          return (
            <div
              key={key}
              style={{ display: "flex", flexDirection: "column", gap: 5 }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <label style={{ minWidth: "100px" }}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flex: 1,
                    gap: 5,
                  }}
                >
                  <textarea
                    value={value || ''}
                    onChange={(e) => handleInputChange(key, e.target.value)}
                    style={{
                      width: '100%',
                      // flex: 1,
                      height:
                        value && countWords(String(value)) > 5 ? '4.5em' : '1.5em', // convert value to string here
                      lineHeight: '1.5em',
                      overflowY: 'auto',
                      resize: 'vertical',
                    }}
                  />

                  {!isImageField(key) &&
                    !value?.includes(".com") && (
                      <button
                        onClick={() => {
                          setAILoadingNow(true);
                          modifyTextAI({
                            text: value,
                            length: value ? countWords(value) + 20 : 100,
                          }).then((res) => {
                            // alert(JSON.stringify(res))
                            if (res) {
                              handleInputChange(key, res);
                            }
                            setAILoadingNow(false);
                          });
                        }}
                        style={{
                          // background: "none",
                          border: "none",
                          cursor: "pointer",
                          backgroundColor: "blue",
                          borderRadius: 100,
                          color: "white",
                        }}
                        title="Generate with AI"
                      >
                        AI (Task)
                      </button>
                    )}
                  {key == 'icon' && (
                    <QuestionAnswer
                      onClick={() => {
                        handleFontAwesomeRedirect()
                      }}
                    />
                  )}
                </div>
              </div>
              {isImageField(key) && (
                <MyMedia
                  fieldValue={value}
                  entry={editedItem}
                  handleNewFile={() => { }}
                  defaultItem={defaultConfig[editSection]}
                />
              )}
            </div>
          );
        })}

        {(editSection == "pricings" || editSection == "pricelists") &&
          myInfo?.token && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flex: 1,
                  gap: 5,
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <textarea
                  // type="text"
                  // type="password"
                  value={stripeKey["key"] || ""}
                  onChange={(e) => {
                    setStripeKey({
                      ...stripeKey,
                      key: e.target.value,
                    });
                  }}
                  style={{
                    // flex: 1,
                    width: '100%',
                    height:
                      stripeKey["key"] && countWords(stripeKey["key"]) > 5
                        ? "4.5em"
                        : "1.5em", // height of one line (adjust as needed)
                    lineHeight: "1.5em", // ensure vertical centering
                    overflowY: "auto",
                    resize: "vertical",
                    width: "100%",
                  }}
                />

              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flex: 1,
                  gap: 5,
                  flexDirection: "column",
                  width: "100%",
                }}
              >

                <textarea
                  // type="password"
                  value={stripeKey["productId"] || ""}
                  onChange={(e) => {
                    setStripeKey({
                      ...stripeKey,
                      productId: e.target.value,
                    });
                  }}
                  style={{
                    // flex: 1,
                    width: '100%',
                    height:
                      stripeKey["productId"] &&
                        countWords(stripeKey["productId"]) > 5
                        ? "4.5em"
                        : "1.5em", // height of one line (adjust as needed)
                    lineHeight: "1.5em", // ensure vertical centering
                    overflowY: "auto",
                    resize: "vertical",
                    width: "100%",
                  }}
                />
              </div>
            </div>
          )}

        <div style={{
          position: "fixed",
          top: 20,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "10px",
          zIndex: 10,
          backgroundColor: "#fff", // optional: white background
          padding: "10px 20px",     // optional: spacing around buttons
          borderTop: "1px solid #ddd", // optional: top border
          boxShadow: "0 -2px 5px rgba(0,0,0,0.1)", // optional: subtle shadow
        }}>
          <button
            disabled={loading}
            style={
              loading
                ? {
                  backgroundColor: "red",
                }
                : {}
            }
            onClick={async () => {
              // if (stripeKey?.productId && stripeKey?.key) {
              saveDataDB({
                query: {
                  date: moment(),
                  handle: myInfo?.handle,
                  siteName: siteName,
                  config: cleanedItem(editedItem)
                },
                keys: ["date", "siteName"],
                resource: "vare_banking_versions",
              }).then((info) => {
                setLoading(true);
                setUploadNow(true);
                onSave(cleanedItem(editedItem));
              });
              // }

              // setLoading(true);
              // setUploadNow(true);
              // onSave(cleanedItem(editedItem));
            }}
            className="btn-main"
          >
            {loading ? "Loading..." : "Save"}
          </button>
          <button disabled={loading} onClick={onClose} className="btn-main">
            Cancel
          </button>
        </div>
      </div>
    </div >
  );
};



const deleteKeyFromObjectIfExists = ({ obj, keyToDelete }) => {
  let keyFound = false;

  const deepDelete = (input) => {
    if (Array.isArray(input)) {
      return input.map(deepDelete);
    }

    if (typeof input === 'object' && input !== null) {
      const newObj = {};
      for (const [key, value] of Object.entries(input)) {
        if (key === keyToDelete) {
          keyFound = true;
          continue;
        }
        newObj[key] = deepDelete(value);
      }
      return newObj;
    }

    return input;
  };

  const result = deepDelete(obj);
  return keyFound ? result : obj;
};


const removeFirstMatch = ({ array, target }) => {
  const index = array.indexOf(target);
  if (index !== -1) {
    return [...array.slice(0, index), ...array.slice(index + 1)];
  }
  return array;
}

const insertStringAtIndex = ({ array, index, newItem }) => {
  return [...array.slice(0, index), newItem, ...array.slice(index)];
}

const reorderArray = ({ array, fromIndex, toIndex }) => {
  if (
    fromIndex < 0 ||
    toIndex < 0 ||
    fromIndex >= array.length ||
    toIndex >= array.length
  ) {
    console.error("Invalid indices");
    return array;
  }

  const newArray = [...array];
  const [movedItem] = newArray.splice(fromIndex, 1); // Remove item from the original position
  newArray.splice(toIndex, 0, movedItem); // Insert item at the new position

  return newArray;
};


const MyMedia = ({ fieldValue, entry, handleNewFile, defaultItem = {} }) => {
  const [formInput, setFormInput] = useState({ picture: fieldValue });
  const [refreshing, setRefreshing] = useState(false);
  const [uploadNow, setUploadNow] = useState(false);
  const [allowAdd, setAllowAdd] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const imgType = ["image", "img", "src", "thumb", "full", "logo"]

  const props = {};
  useEffect(() => {

    if (formInput?.picture) {
      let key = ''
      imgType?.map(res => {
        if (typeof entry == 'object'
          && Object.keys(entry)?.includes(res)) {
          key = res
        }
      })
      if (key) {
        entry[key] = formInput.picture;
        // console.log('ssssssssxx5', entry)
        handleNewFile(entry)
      }
    }
    setAllowAdd((selectedImage && (selectedImage != formInput?.picture)) ? true : false)

  }, [
    formInput?.picture,
    selectedImage,
    entry
  ]);


  // console.log('defaultItemxx', entry, defaultItem)
  return (
    <>
      <MyFileUploader
        {...props}
        defaultItem={entry?.["image"]}
        handleCancel={() => {
          setSelectedImage('')
          setFormInput({
            ...formInput,
            picture: entry?.image
          })
        }}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
        imageKey={"picture"}
        aiSearchBy={"industry"}
        resource={"gaming_site_media"}
        refreshing={refreshing}
        setRefreshing={setRefreshing}
        setFormInput={setFormInput}
        formInput={formInput}
        uploadNow={uploadNow}
        allowAdd={allowAdd}
        handleSaveImage={() => {
          setUploadNow(true)
        }}
      />
    </>
  );
};

const AiPromptBox = ({ handleText, aiLoading }) => {
  const [inputAIText, setInputAIText] = useState('');

  const onGenerate = () => {
    if (inputAIText.trim()) {
      handleText(inputAIText);
      // setInputText(''); // Optionally clear the textarea after submission
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      <textarea
        value={inputAIText}
        onChange={(e) => setInputAIText(e.target.value)}
        placeholder="Use AI assistance to generate contents, type in what you want"
        rows={4}
        style={{ width: '100%', padding: '10px', fontSize: '14px' }}
      />
      <button onClick={onGenerate} className="btn-main">
        {aiLoading ? 'Loading...' : 'Generate'}
      </button>

      <button onClick={() => {
        setInputAIText('')
      }} className="btn-main">
        Clear AI Assist
      </button>
    </div>
  );
};









